// src/features/clinical/services/clinicalMockData.js
export const mockPatients = [
  {
    id: 'P001',
    patientId: 'PT-1001',
    name: 'John Doe',
    age: 45,
    dateOfBirth: '1979-05-15',
    gender: 'Male',
    contact: '+1234567890',
    email: 'john.doe@email.com',
    address: '123 Main St, New York, NY',
    bloodGroup: 'O+',
    allergies: ['Penicillin', 'Peanuts'],
    chronicConditions: ['Hypertension'],
    emergencyContact: 'Jane Doe - +1234567891',
    registrationDate: '2024-01-15T10:30:00Z',
    status: 'ACTIVE'
  },
  {
    id: 'P002',
    patientId: 'PT-1002',
    name: 'Jane Smith',
    age: 32,
    dateOfBirth: '1992-08-22',
    gender: 'Female',
    contact: '+1234567891',
    email: 'jane.smith@email.com',
    address: '456 Oak Ave, Los Angeles, CA',
    bloodGroup: 'A+',
    allergies: ['Sulfa'],
    chronicConditions: ['Asthma'],
    emergencyContact: 'John Smith - +1234567890',
    registrationDate: '2024-01-20T14:20:00Z',
    status: 'ACTIVE'
  }
];

export const mockVisits = [
  {
    id: 'V001',
    visitId: 'VIS-2024-001',
    patientId: 'P001',
    patientName: 'John Doe',
    visitDate: '2024-03-15T09:30:00Z',
    visitType: 'CONSULTATION',
    doctorId: 'D001',
    doctorName: 'Dr. Smith',
    department: 'General Medicine',
    chiefComplaint: 'Fever and cough for 3 days',
    vitals: {
      temperature: 38.5,
      heartRate: 82,
      respiratoryRate: 18,
      bloodPressureSystolic: 128,
      bloodPressureDiastolic: 82,
      oxygenSaturation: 98,
      height: 175,
      weight: 78,
      bmi: 25.5,
      painLevel: 6
    },
    symptoms: ['Fever', 'Cough', 'Fatigue'],
    diagnosis: 'Upper respiratory infection',
    status: 'COMPLETED',
    followUpDate: '2024-03-22'
  },
  {
    id: 'V002',
    visitId: 'VIS-2024-002',
    patientId: 'P002',
    patientName: 'Jane Smith',
    visitDate: '2024-03-16T10:15:00Z',
    visitType: 'FOLLOW_UP',
    doctorId: 'D002',
    doctorName: 'Dr. Johnson',
    department: 'Pulmonology',
    chiefComplaint: 'Shortness of breath',
    vitals: {
      temperature: 36.8,
      heartRate: 76,
      respiratoryRate: 20,
      bloodPressureSystolic: 118,
      bloodPressureDiastolic: 76,
      oxygenSaturation: 95,
      height: 162,
      weight: 58,
      bmi: 22.1,
      painLevel: 3
    },
    symptoms: ['Shortness of breath', 'Wheezing'],
    diagnosis: 'Asthma exacerbation',
    status: 'IN_PROGRESS',
    followUpDate: null
  }
];

export const mockPrescriptions = [
  {
    id: 'PR001',
    prescriptionId: 'RX-2024-001',
    visitId: 'V001',
    patientId: 'P001',
    patientName: 'John Doe',
    doctorId: 'D001',
    doctorName: 'Dr. Smith',
    prescriptionDate: '2024-03-15T10:00:00Z',
    medicines: [
      {
        medicineId: '1',
        medicineName: 'Amoxicillin',
        dosage: '500mg',
        frequency: 'Twice daily',
        duration: '7 days',
        quantity: 14,
        route: 'Oral',
        instructions: 'Take after food',
        substitutionAllowed: true
      },
      {
        medicineId: '2',
        medicineName: 'Paracetamol',
        dosage: '650mg',
        frequency: 'Three times daily',
        duration: '3 days',
        quantity: 9,
        route: 'Oral',
        instructions: 'For fever > 101°F',
        substitutionAllowed: true
      }
    ],
    tests: [
      {
        testId: 'T001',
        testName: 'Complete Blood Count',
        instructions: 'Fasting not required',
        priority: 'URGENT'
      },
      {
        testId: 'T002',
        testName: 'Chest X-Ray',
        instructions: 'Bring previous reports',
        priority: 'ROUTINE'
      }
    ],
    notes: 'Patient advised to drink plenty of fluids and rest',
    followUpInstructions: 'Return if fever persists after 3 days',
    status: 'ACTIVE'
  }
];

export const mockDoctors = [
  {
    id: 'D001',
    name: 'Dr. Smith',
    specialization: 'General Medicine',
    licenseNumber: 'LIC-12345',
    availability: ['Monday', 'Wednesday', 'Friday']
  },
  {
    id: 'D002',
    name: 'Dr. Johnson',
    specialization: 'Pulmonology',
    licenseNumber: 'LIC-12346',
    availability: ['Tuesday', 'Thursday']
  }
];

export const mockMedicines = [
  {
    id: '1',
    name: 'Amoxicillin',
    category: 'Antibiotics',
    manufacturer: 'PharmaCorp',
    unit: 'Capsule',
    strength: '500mg',
    price: 5.99,
    currentStock: 150,
    reorderLevel: 50,
    expiryDate: '2025-12-31',
    batchNumber: 'BATCH001'
  },
  {
    id: '2',
    name: 'Paracetamol',
    category: 'Pain Relief',
    manufacturer: 'MediHealth',
    unit: 'Tablet',
    strength: '650mg',
    price: 2.99,
    currentStock: 500,
    reorderLevel: 100,
    expiryDate: '2025-06-30',
    batchNumber: 'BATCH002'
  }
];

export const mockTests = [
  {
    id: 'T001',
    name: 'Complete Blood Count',
    category: 'Hematology',
    preparation: 'No special preparation required',
    turnaroundTime: '24 hours',
    price: 50.00
  },
  {
    id: 'T002',
    name: 'Chest X-Ray',
    category: 'Radiology',
    preparation: 'Remove metallic objects',
    turnaroundTime: '2 hours',
    price: 120.00
  },
  {
    id: 'T003',
    name: 'Blood Glucose Fasting',
    category: 'Biochemistry',
    preparation: 'Fast for 8-10 hours',
    turnaroundTime: '4 hours',
    price: 30.00
  }
];